// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  height: 100%;
}

.item-row {
  height: 100%;
  border-radius: 35px;
  padding: 20px 7%;
  position: relative;
  overflow: hidden;
  transition: border 0.2s ease-in-out;
  background: var(--default-background);
  border: 1px solid transparent;
}
.item-row.inactive {
  opacity: 0.3;
}

.item-row:hover {
  border: 1px solid #272727;
}
.item-row:hover .add-icon {
  background: #f48b7f;
}
.item-row:hover .add-icon ion-icon {
  color: white;
}
.item-row:hover ion-button {
  --background: #f2dbd9;
}

.item-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.new {
  position: absolute;
  height: 25px;
  width: 60px;
  top: -8px;
  right: -5px;
  z-index: 1;
}

.img-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.img-wrapper.block-adding ion-img {
  opacity: 0.3;
}
.img-wrapper.block-adding ion-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;
  width: 40px;
  height: 40px;
}

.item-image {
  width: 80%;
  aspect-ratio: 1;
  margin-bottom: 10px;
  max-height: 200px;
}

.cover-image {
  object-fit: cover;
}

.item-name {
  max-width: 50%;
  font-size: 14px;
  line-height: 16.8px;
  letter-spacing: 0;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 15px;
}

.item-info {
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.08em;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 15px;
}

.price-row {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}
.price-row .price {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 16.8px;
  letter-spacing: 0;
  text-align: center;
  text-transform: uppercase;
}
.price-row .kcall {
  position: relative;
  font-size: 14px;
  line-height: 16.8px;
  letter-spacing: 0%;
  text-align: center;
  text-transform: uppercase;
}
.price-row .kcall,
.price-row .tags {
  position: relative;
  height: 17px;
  margin-left: 12px;
}
.price-row .kcall::before,
.price-row .tags::before {
  content: "";
  position: absolute;
  left: -6px;
  width: 1.5px;
  height: 100%;
  background: var(--color-black);
}

.buttons {
  margin-top: auto;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
.buttons ion-button {
  width: 50%;
  height: 36px;
  --background: #ebdfda;
  font-size: 11px;
  --color: var(--color-black);
  --border-width: 0px;
  text-wrap: auto;
}
.buttons .add-button {
  --background: var(--ion-color-primary);
  --color: white ;
}
.buttons .not-enough {
  --color: var(--color-black);
  opacity: 0.5;
}
.buttons .not-enough ion-icon {
  margin-right: 10px;
}

.progress-bar {
  position: absolute;
  bottom: -20px;
  width: 120%;
  --progress-background: #F48B7F;
  --buffer-background: #EBDFDA;
}

.add-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #ebdfda;
}
.add-icon ion-icon {
  margin: 0px;
  color: var(--color-black);
  width: 40px;
  height: 40px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/loyalty-components/promocode-buyed-by-points/promocode-buyed-by-points.component.scss"],"names":[],"mappings":"AAEA;EACE,cAAA;EACA,YAAA;AADF;;AAIA;EACE,YAAA;EAED,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mCAAA;EACA,qCAAA;EACA,6BAAA;AAFD;AAGC;EACC,YAAA;AADF;;AAOA;EACC,yBAAA;AAJD;AAKC;EACC,mBAAA;AAHF;AAIE;EACC,YAAA;AAFH;AAKC;EACC,qBAAA;AAHF;;AAOA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAJD;;AAOA;EACC,kBAAA;EACA,YAAA;EACA,WAAA;EACG,SAAA;EACA,WAAA;EACH,UAAA;AAJD;;AAMA;EACC,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAHD;AAME;EACC,YAAA;AAJH;AAME;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AAJH;;AAQA;EACC,UAAA;EACA,eAAA;EACA,mBAAA;EACG,iBAAA;AALJ;;AAQA;EACC,iBAAA;AALD;;AAQA;EACC,cAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EAEA,mBAAA;AAND;;AASA;EACC,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EAEA,mBAAA;AAPD;;AAUA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EAEC,mBAAA;AARF;AAWC;EACC,wBAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AATF;AAaC;EACC,kBAAA;EAEA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;AAZF;AAcC;;EAEC,kBAAA;EACA,YAAA;EACA,iBAAA;AAZF;AAeC;;EAEC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,8BAAA;AAbF;;AAiBA;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AAdF;AAgBE;EACE,UAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,2BAAA;EACH,mBAAA;EACC,eAAA;AAdF;AAgBE;EACD,sCAAA;EACA,eAAA;AAdD;AAgBE;EACE,2BAAA;EACA,YAAA;AAdJ;AAeC;EACC,kBAAA;AAbF;;AAkBA;EACI,kBAAA;EACA,aAAA;EACA,WAAA;EACH,8BAAA;EACA,4BAAA;AAfD;;AAiBA;EACC,WAAA;EACG,YAAA;EACA,kBAAA;EACH,mBAAA;AAdD;AAeC;EACC,WAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;AAbF","sourcesContent":["@import '../../../../theme/mixins';\n\n:host {\n  display: block;\n  height: 100%;\n}\n\n.item-row {\n  height: 100%;\n\n\tborder-radius: 35px;\n\tpadding: 20px 7%;\n\tposition: relative;\n\toverflow: hidden;\n\ttransition: border 0.2s ease-in-out;\n\tbackground: var(--default-background);\n\tborder: 1px solid transparent;\n\t&.inactive {\n\t\topacity: 0.3;\n\t  }\n  // @include mobile {\n  //   margin-bottom: 12px;\n  // }\n}\n.item-row:hover{\n\tborder: 1px solid #272727;\n\t.add-icon {\n\t\tbackground: #f48b7f;\n\t\tion-icon {\n\t\t\tcolor:white;\n\t\t}\n\t}\n\tion-button {\n\t\t--background: #f2dbd9;\n\t}\n}\n\n.item-col {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.new {\n\tposition: absolute;\n\theight: 25px;\n\twidth: 60px;\n    top: -8px;\n    right: -5px;\n\tz-index: 1;\n}\n.img-wrapper {\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tposition: relative;\n\t&.block-adding{\n\n\t\tion-img {\n\t\t\topacity: 0.3;\n\t\t}\n\t\tion-icon {\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 50%;\n\t\t\ttransform: translate(-50%,-50%);\n\t\t\tz-index: 99;\n\t\t\twidth: 40px;\n\t\t\theight: 40px;\n\t\t}\n\t}\n}\n.item-image {\n\twidth: 80%;\n\taspect-ratio: 1;\n\tmargin-bottom: 10px;\n    max-height: 200px;\n}\n\n.cover-image {\n\tobject-fit: cover;\n}\n\n.item-name {\n\tmax-width: 50%;\n\tfont-size: 14px;\n\tline-height: 16.8px;\n\tletter-spacing: 0;\n\ttext-align: center;\n\ttext-transform: uppercase;\n\n\tmargin-bottom: 15px;\n}\n\n.item-info {\n\tfont-size: 10px;\n\tline-height: 12px;\n\tletter-spacing: 0.08em;\n\ttext-align: center;\n\ttext-transform: uppercase;\n\n\tmargin-bottom: 15px;\n}\n\n.price-row {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n  \n  margin-bottom: 20px;\n \n  \n\t.price {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\tline-height: 16.8px;\n\t\tletter-spacing: 0;\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\n\t}\n\n\t.kcall {\n\t\tposition: relative;\n\n\t\tfont-size: 14px;\n\t\tline-height: 16.8px;\n\t\tletter-spacing: 0%;\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\t}\n\t.kcall,\n\t.tags {\n\t\tposition: relative;\n\t\theight: 17px;\n\t\tmargin-left: 12px;\n\t}\n\n\t.kcall::before,\n\t.tags::before {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\tleft: -6px;\n\t\twidth: 1.5px;\n\t\theight: 100%;\n\t\tbackground: var(--color-black);\n\t}\n}\n\n.buttons {\n  margin-top: auto;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n\n  ion-button {\n    width: 50%;\n    height: 36px;\n    --background:  #ebdfda;\n    font-size: 11px;\n    --color: var(--color-black);\n\t--border-width: 0px;\n\t\ttext-wrap: auto;\n  }\n  .add-button {\n\t--background: var(--ion-color-primary);\n\t--color: white\n  }\n  .not-enough {\n    --color: var(--color-black);\n    opacity: 0.5;\n\tion-icon  {\n\t\tmargin-right: 10px;\n\t  }\n  }\n\n}\n.progress-bar {\n    position: absolute;\n    bottom: -20px;\n    width: 120%;\n\t--progress-background: #F48B7F;\n\t--buffer-background: #EBDFDA;\n}\n.add-icon {\n\twidth: 40px;\n    height: 40px;\n    border-radius: 50%;\n\tbackground: #ebdfda;\n\tion-icon {\n\t\tmargin: 0px;\n\t\tcolor: var(--color-black);\n\t\twidth: 40px;\n\t\theight: 40px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
